"use client";

import { useState } from "react";
import { Map, SlidersHorizontal } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";
import { SearchInput } from "./search-input";
import { PhoneFilterSheet, usePhoneFilterCount } from "./phone-filter-sheet";
import { useListingBrowseContext } from "../context/listing-browse-context";

function PhoneMapButton({ onOpenMap }: { onOpenMap: () => void }) {
  return (
    <IconButton
      variant="outline"
      size="default"
      onClick={onOpenMap}
      aria-label="Show map"
      className="size-11 shrink-0"
    >
      <Map />
    </IconButton>
  );
}

export function PhoneFilterBar({
  onOpenMap,
  resultCount,
}: {
  onOpenMap: () => void;
  resultCount: number | null;
}) {
  const [sheetOpen, setSheetOpen] = useState(false);
  const count = usePhoneFilterCount();
  const { mapAvailable } = useListingBrowseContext();
  return (
    <div className="flex items-center gap-2 px-4 py-2 md:hidden">
      <SearchInput
        id="marketplace-filter-search-phone"
        className="min-w-0 flex-1"
      />
      <Button
        type="button"
        variant="outline"
        size="default"
        onClick={() => setSheetOpen(true)}
        aria-label={count > 0 ? `Filters, ${count} active` : "Filters"}
        className="h-11 min-w-11 shrink-0"
      >
        <SlidersHorizontal />
        {count > 0 ? (
          <span className="inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-sm bg-action-fill px-1 text-xs font-semibold text-action-fill-foreground">
            {count}
          </span>
        ) : null}
      </Button>
      {mapAvailable ? <PhoneMapButton onOpenMap={onOpenMap} /> : null}
      <PhoneFilterSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        resultCount={resultCount}
      />
    </div>
  );
}
